import React, { type FunctionComponent } from 'react'
import { FormattedMessage } from 'react-intl'
import { Breadcrumb } from 'legacy/components/Breadcrumbs'
import { StoreGroupsListBreadcrumbs } from 'legacy/sections/store-groups/components/breadcrumbs/components/StoreGroupsListBreadcrumbs'

export const StoreGroupsEditBreadcrumbs: FunctionComponent = () => (
  <StoreGroupsListBreadcrumbs>
    <Breadcrumb>
      <FormattedMessage id="settings.storeGroups.edit.title" />
    </Breadcrumb>
  </StoreGroupsListBreadcrumbs>
)
